module.exports = __webpack_public_path__ + "img/서브6_패스킥슛.02e2a19e.svg";